export enum SalutationOptions {
    notSpecified = 'notSpecified',
    mister = 'mister',
    missis = 'missis',
}
